import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Fade from '@mui/material/Fade';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WebsiteAgreementText from './WebsiteAgreementText';
import WebsiteAgreementActions from './WebsiteAgreementActions';
import { useOnboardingContext } from '../../../Contexts/OnboardingContext';
import OnboardingHeader from '../../../Components/Header';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentWrapper: {
    maxWidth: theme.dimensions.xl,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    padding: theme.spacing(4, 0),
  },
});

const WebsiteAgreement = ({
  className,
  classes,
  isSavingResponse,
  savingResponseError,
  onAgree,
  navigateToDeclined,
}) => {
  const { clientResource } = useOnboardingContext();
  const isPrimaryClient = clientResource.attr('isPrimary') === 'true';

  return (
    <Fade in>
      <Box
        className={classNames(classes.root, className)}
      >
        <Box className={classes.contentWrapper}>
          {/* ------- AGREEMENT HEADER ------- */}
          <OnboardingHeader
            title={'Website Agreement'}
            centered
          />

          {/* ------- AGREEMENT TEXT ------- */}
          <WebsiteAgreementText
            isPrimaryClient={isPrimaryClient}
          />

          {/* ------- AGREEMENT ACTIONS ------- */}
          <WebsiteAgreementActions
            isPrimaryClient={isPrimaryClient}
            isSavingResponse={isSavingResponse}
            savingResponseError={savingResponseError}
            onAgree={onAgree}
            navigateToDeclined={navigateToDeclined}
          />
        </Box>
      </Box>
    </Fade>
  );
};

WebsiteAgreement.defaultProps = {
  className: '',
  savingResponseError: null,
};

WebsiteAgreement.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isSavingResponse: PropTypes.bool.isRequired,
  savingResponseError: PropTypes.object,
  onAgree: PropTypes.func.isRequired,
  navigateToDeclined: PropTypes.func.isRequired,
};

export default withStyles(styles)(WebsiteAgreement);
